export const extendedTypesInfo = {
  // HTMLAttributes is removed from display if any of the following elements also exist
  HTMLAttributes: {
    name: 'HTMLElement',
    url: 'https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement',
  },
  SelectHTMLAttributes: {
    name: 'HTMLSelectElement',
    url: 'https://developer.mozilla.org/en-US/docs/Web/API/HTMLSelectElement',
  },
  TextareaHTMLAttributes: {
    name: 'HTMLTextAreaElement',
    url: 'https://developer.mozilla.org/en-US/docs/Web/API/HTMLTextAreaElement',
  },
  InputHTMLAttributes: {
    name: 'HTMLInputElement',
    url: 'https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement',
  },
  AnchorHTMLAttributes: {
    name: 'HTMLAnchorElement',
    url: 'https://developer.mozilla.org/en-US/docs/Web/API/HTMLAnchorElement',
  },
  ButtonHTMLAttributes: {
    name: 'HTMLButtonElement',
    url: 'https://developer.mozilla.org/en-US/docs/Web/API/HTMLButtonElement',
  },
};
